<template>
  <div>
    <div class="store" :class="`store--brand__${store.brand.toLowerCase()} store--${store.branchType.toLowerCase()}`">
      <div class="store--inner">
        <h3>{{ store.name }}</h3>
        <p v-if="content[`branchTypeAdvisory${capitalCase(store.branchType)}`]" :class="`store--brand__${store.branchType}`">
          {{ content[`branchTypeAdvisory${capitalCase(store.branchType)}`] }}
        </p>
        <p>Distance: {{ store.distanceInMiles }} miles</p>
      </div>
    </div>

    <div v-if="!IsPayPoint">
      <div v-if="store.availableFrom">
        <div v-if="store.haveCurrency && isSellTransaction" class="store--stock available">
          <p>In Stock - Collect 
          <span v-html="$options.filters.availableMessage(store.availableFrom, '')" />
          </p>
        </div>
        <div v-else>
          <p>Collect in branch 
            <span v-if="store.haveCurrency || store.isBuyTransaction" v-html="$options.filters.availableMessage(store.availableFrom, '')" />
            <span v-else v-html="$options.filters.availableMessage(store.availableFrom, '2pm')" />
          </p>
        </div>
      </div>
      <div v-else>
        <div class="store--stock closed">
          <p>Sorry we're closed this week!</p>
        </div>
      </div>
   </div>

    <div v-if="IsPayPoint && store.availableFrom" class="button button--small button--show-stores pp-stores">
      <div v-if="store.haveCurrency && isSellTransaction" class="store--stock available">
         <p class="pp-stor">In Stock - 
          <span class="pp-collect"> Collect 
            <span v-html="$options.filters.availableMessage(store.availableFrom, '')" />
          </span>
          </p>
       </div>
       <div v-else>
         <p class="pp-stor">
            <span class="pp-collect"> Collect 
              <span v-if="store.haveCurrency || store.isBuyTransaction" v-html="$options.filters.availableMessage(store.availableFrom, '')" />
              <span v-else v-html="$options.filters.availableMessage(store.availableFrom, '2pm')" />
            </span>
          </p>
       </div>   
    </div>

    <div
      v-if="expanded"
      class="store--info"
    >
      <times :storeId="store.id" />

      <div class="store--address">
        <b>Collection address</b>

        <div class="address">
          <span
            v-if="
              store.brandName ||
              (store.brand && store.name)
            "
          >
            {{ store.brandName || store.brand }}
            {{ store.name }},
          </span>
          <span v-if="address !=null">
            <span v-if="address.address1"> {{ address.address1 }}, </span>
            <span v-if="address.address2"> {{ address.address2 }}, </span>
            <span v-if="address.address3"> {{ address.address3 }}, </span>
            <span v-if="address.address4"> {{ address.address4 }}, </span>
            <span v-if="address.postcode">{{ address.postcode }}</span>
          </span>
        </div>
        <div class="brand" :class="store.brand"></div>
      </div>
    </div>
    
    <button
      v-if="!store.haveNoOpeningTimes"
      class="button button--small button--show-stores"
      :class="{ 'active': expanded, 'pp-popup pp-showInfo' : IsPayPoint }"
      @click="toggleExpanded()"
    >

      {{ expanded ? (content.hideBranchInfo || 'Hide branch information &#9650;') : (content.showBranchInfo ||  'Show branch information &#9660;') }}
    </button>

    <button
      v-if="!store.haveNoOpeningTimes"  
      class="button button--small button--primary"
      :class="{ 'pp-confirm' : IsPayPoint }"
      @click="confirmStoreSelection"
    >
      {{ content.confirmStoreSelection || 'Confirm' }}

    </button>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'

import { capitalCase } from 'change-case'
import { getStoreAddress } from '@vue/services/api/store.api'
import Times from '@vue/common/components/times'
import { SITE_NAME } from '@vue/common/constants/config'
import { computeAvailableMessage } from '@vue/common/filters/computeAvailableMessage.filter'

const { mapFields } = createHelpers({
  getterType: 'store/getField',
  mutationType: 'store/updateField',
})

export default {
  name: 'Store',
  props: ['store'],
  data() {
    return {
      SITE_NAME,
      IsPayPoint:false,
      address: null,
      capitalCase: capitalCase,
      expanded: false
    }
  },
  components: {
    Times,
  },
  computed: {
    ...mapState({
      content: (state) => state.calculator.content,
    }),
    ...mapGetters({
      isSellTransaction: 'calculator/isSellTransaction',
      isBuyTransaction: 'calculator/isBuyTransaction',
    })
  },
  filters: {
    availableMessage(isoDate, from) {
      return computeAvailableMessage(isoDate, from);
    } 
  },
  methods: {
    ...mapActions({
      toggleStoreModal: 'calculator/toggleStoreModal',
      updateQuote: 'calculator/updateQuote'
    }),
    ...mapMutations({
      setStore: 'store/setStore',
    }),
    confirmStoreSelection() {
      document.body.removeAttribute('class');
      this.setStore(this.store)

      // Because increment would change if switching to / from Express store
      this.updateQuote(); 

      this.toggleStoreModal(false)
    },
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
    getOrdinal(day) {
      if (day > 3 && day < 21) return 'th'
      switch (day % 10) {
        case 1:
          return 'st'
        case 2:
          return 'nd'
        case 3:
          return 'rd'
        default:
          return 'th'
      }
    },
    getAddress() {
      getStoreAddress(this.store.id).then((response) => {
        this.address = response.data
      })
    }
  },
  updated() {
    this.getAddress();
  },
  mounted() {
    this.getAddress();
    this.IsPayPoint = (SITE_NAME == 'PAYPOINT')
  },
}
</script>

<style lang="scss">
.button--show-stores {
  width: 100%;
  background: #A9A9A9;
  border: solid 1px #A9A9A9;

  color: #fff;

  &:hover {
    background: darken(#A9A9A9, 20);
    cursor: pointer;
  }

}
.pp-stores {
  background:#fff !important; 
  border: none;
  margin-top: 8px !important; 
}
.pp-stor{
  color:#93d500;text-align: center
}
.pp-popup{  
    margin-top: 8px !important; 
    color: #007ea0 !important; 
}
.pp-confirm{  
    margin-top: 8px !important; 
}
.pp-showInfo{
  background: #ffff;
  width: 100%;
  border: 1px solid #007ea0 !important; 
   
  &:hover {
     color: #fff !important; 
    cursor: pointer;
  }
}
.pp-collect {
  color: #000000;
}
</style>
